import React, { Component } from 'react';
import {Input,Modal,Row,Col, Form,Icon, Button, Select, DatePicker,message, InputNumber,Drawer } from 'antd';
import {pepoleWip,mailFinder} from '../../stores/APIEndpoints';
import {booleanAsString, toUrlParams} from "../../stores/Util";
import DynamicForm from "../../components/DynamicForm";
import looseLeafStore from "../../stores/LooseLeafStore";
import {appStore} from '../../stores/AppStore';
import {inject, observer} from 'mobx-react';
import DashboardStore from '../../stores/DashboardStore';
const { Option } = Select;
import '../../../src/index.css';
import moment from 'moment';


@inject('dataStore')
@observer
class LooseLeafPeopleDrawer extends Component {
  
    constructor(props) {
        super(props);
        this.apiProxy = appStore.apiProxy;
        this.state = {
          updateWIP :'',
          visible:false,
          inputConfirmValue:'',
          errormsg:false,
          rollValue:'',
          children : []
        }
    }
    get store() {
        return DashboardStore;
      
    }
    async componentDidMount() {
      

    }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        
          let data={};
          data.authorEmails = values.authorEmails;
          // data.authorNames = values.authorNames;
          data.cmEmails = values.cmEmails;
          // data.cmNames = values.cmNames;
          data.editorEmails = values.editorEmails;
          // data.editorNames = values.editorNames;
          this.store.savePeopleInfo(data);
      }
    });
  };
  getReseedAuthor=async(roll)=>{
    
  }
  getUpdateWip = async(roll)=>{
    const data = this.store.currentData;
    let replace={};
    this.props.form.validateFields((err, values) => {
      if (!err) {
          if(roll == 1)
          {
            replace.email = values.authorEmails.toString().split(" ").join("").split(',').join(';');;
            replace.name = values.author;
          }
          else if(roll == 72)
          {
            replace.email = values.cmEmails.toString().split(" ").join("").split(',').join(';');;
            replace.name = values.cm;
          }
          else if(roll == 70)
          {
            replace.email = values.editorEmails.toString().split(" ").join("").split(',').join(';');;
            replace.name = values.editor;
          }
      }
    });
    const bodyParams = {
      "replace":replace,
      "project_id": data.projectId,
      "role_id":roll
    }
 
    let response = await this.apiProxy.asyncPost(pepoleWip, bodyParams);
    const option = await response.json();
    this.setState({updateWIP:option})
    if(option.message=="Updated Successfully")
    {
      message.success('Updated Successfully');
      this.store.fetchData();
    }
    else
    {
      message.error('Provide valid data');
      this.store.fetchData();
    }
   }

   updateWip = async(roll)=>{
     this.setState({visible: true});
     this.setState({rollValue: roll});
  }
  handleOk = e => {
    const currentData = this.store.currentData;
    if(this.state.inputConfirmValue == currentData.publication)
    {
      this.setState({
        visible: false,
      });
      this.setState({errormsg:false})
      this.setState({
        inputConfirmValue: ''
      });
      this.getUpdateWip(this.state.rollValue);
    }
    else{
      this.setState({errormsg:true})
    }
  };
  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
          let data={};
          
           //data.authorNames =values.future_author;
         if(values.future_authorEmails != undefined)
         {
          data.authorEmails = values.future_authorEmails.toString().split(" ").join("").split(',').join(';'); 
         }
        // data.cmNames = values.future_cm;
         if(values.future_cmEmails != undefined)
         {
          data.cmEmails = values.future_cmEmails.toString().split(" ").join("").split(',').join(';'); ;
         }
        //  data.editorNames = values.future_editor;
         if(values.future_editorEmails != undefined)
         {
          data.editorEmails = values.future_editorEmails.toString().split(" ").join("").split(',').join(';'); ;
         }
          this.store.updateItem(data);
      }
    });
  };

handleChange=(value)=> {
  this.setState({children:[]});
 
}
validationText= async(value)=>{
  
  if(value.match(/@/g))
  {
    const params = {
      email:value
   };
    const url = mailFinder + '?' + toUrlParams(params);
    const response = await this.apiProxy.getAsync(url);
    const data = await response.json();
    const childrenData = [];
    if(data.length != 0)
    {
      for (let i = 0; i < data.length; i++) {
        childrenData.push(<Option key={data[i].name}>{data[i].name}</Option>);
      }
    }
    else
    {
      message.error('Please register new user.');
    }
     
     this.setState({children:childrenData});
     console.log(this.setState.children);
   
    
  }
  else
  {
  //	alert("false");
  }
}
clearChildred=()=>{
  this.setState({children:[]});
}
  renderPeopleForm = () => {
    const { getFieldDecorator } = this.props.form;
    const data = this.store.currentData;

    let authorEmails = '';
    if(data.future_authorEmails != null && data.future_authorEmails != undefined && data.future_authorEmails!='')
    {
      authorEmails = data.future_authorEmails.split(';');
    }
    else
    {
      authorEmails = data.future_authorEmails
    }
    let futureCmEmails = '';
    if(data.future_cmEmails != null && data.future_cmEmails != undefined && data.future_cmEmails!='')
    {
      futureCmEmails = data.future_cmEmails.split(';');
    }
    else
    {
      futureCmEmails = data.future_cmEmails;
    }
    let futureEditorEmails = '';
    if(data.future_editorEmails != null && data.future_editorEmails != undefined && data.future_editorEmails!='')
    {
      futureEditorEmails = data.future_editorEmails.split(';');
    }
    else
    {
      futureEditorEmails = data.future_editorEmails;
    }
    
    const fieldDefs = [
      {
        key: "authorNames",
        label: "Author Names :",
        type: "text",
        defaultValue: data.future_author,
        disabled: false
    },{
        key: "authorEmails",
        label: "Author Emails :",
        type: "text",
        defaultValue: data.future_authorEmails,
        disabled: false
    }, 
    {
      key: "cmNames",
      label: "CM Names :",
      type: "text",
      defaultValue: data.future_cm,
      disabled: false
  }, {
        key: "cmEmails",
        label: "CM Emails :",
        type: "text",
        defaultValue: data.future_cmEmails,
        disabled: false
    },
    {
      key: "editorNames",
      label: "Editor Names :",
      type: "text",
      defaultValue: data.future_editor,
      disabled: false
  },  {
        key: "editorEmails",
        label: "Editor Emails :",
        type: "text",
        defaultValue: data.future_editorEmails,
        disabled: false
    }];
    // if(data.stage=="In Acquisition")
    // {   
    //   fieldDefs[0].disabled = true;
    //   fieldDefs[1].disabled = true;
    //   fieldDefs[2].disabled = true;
    //   fieldDefs[3].disabled = true;
    //   fieldDefs[4].disabled = true;
    //   fieldDefs[5].disabled = true;
    // }

    return (
            <div>
            <Form name="normal_login"  className="login-form" initialValues={{ remember: true }} onSubmit={this.handleSubmit}>
            <h3 style={{"margin-top":"0px"}}>People - Next cycle</h3>
            <Form.Item label="Author Names"  name="Author" >
          {getFieldDecorator('future_author', {
              initialValue:data.future_author,
              rules: []
              })(
              <Input disabled style={{ width: '100%' }} />
              )}
          </Form.Item>
         
             {/* <Form.Item label="Author Emails"  name="AuthorEmails" >
              {getFieldDecorator('future_authorEmails', {
                  initialValue:data.future_authorEmails,
                  rules: []
                  })(
                  <Input style={{ width: '100%' }} />
                  )}
              </Form.Item> */}
           
              <Form.Item label="Author Emails"  name="AuthorEmails" >
              {getFieldDecorator('future_authorEmails', {
                  initialValue:authorEmails,
                  rules: []
                  })(
                    <Select
                      mode="multiple"
                      style={{ width: '100%' }}
                      placeholder="Please select"
                      onSearch={this.validationText}
                      onChange={this.handleChange}
                      
                    >
                      {this.state.children}
                    </Select>,
                    )}
              </Form.Item>

         <Form.Item label="CM Names"  name="Cm" >
         {getFieldDecorator('future_cm', {
             initialValue:data.future_cm,
             rules: []
            })(
             <Input disabled style={{ width: '100%' }} />
            )}
         </Form.Item>
        
              {/* <Form.Item label="CM Emails"  name="CmEmails" >
              {getFieldDecorator('future_cmEmails', {
                  initialValue:data.future_cmEmails,
                  rules: []
                  })(
                  <Input style={{ width: '100%' }} />
                  )}
              </Form.Item> */}

              <Form.Item label="CM Emails"  name="CmEmails" >
              {getFieldDecorator('future_cmEmails', {
                  initialValue:futureCmEmails,
                  rules: []
                  })(
                    <Select
                      mode="multiple"
                      style={{ width: '100%' }}
                      placeholder="Please select"
                      onSearch={this.validationText}
                      onChange={this.handleChange}
                    >
                      {this.state.children}
                    </Select>,
                    )}
              </Form.Item>


         <Form.Item label="Editor Names"  name="Editor" >
         {getFieldDecorator('future_editor', {
             initialValue:data.future_editor,
             rules: []
            })(
             <Input disabled style={{ width: '100%' }} />
            )}
         </Form.Item>
            {/* <Form.Item label="Editor Emails"  name="EditorEmails" >
            {getFieldDecorator('future_editorEmails', {
                initialValue:data.future_editorEmails,
                rules: []
                })(
                <Input style={{ width: '100%' }} />
                )}
            </Form.Item> */}
            <Form.Item label="Editor Emails"  name="EditorEmails" >
              {getFieldDecorator('future_editorEmails', {
                  initialValue:futureEditorEmails,
                  rules: []
                  })(
                    <Select
                      mode="multiple"
                      style={{ width: '100%' }}
                      placeholder="Please select"
                      onSearch={this.validationText}
                      onChange={this.handleChange}
                    >
                      {this.state.children}
                    </Select>,
                    )}
              </Form.Item>
       </Form>
       <Button style={{"float":"right","margin-top":"10px"}} type="primary" onClick={this.handleSubmit} className="login-form-button">Update </Button>

              {/* <DynamicForm
                  items={fieldDefs}
                  onSubmit={data => this.store.updateItem(data)}
                  submitButtonText={'Save and Next'}
                  submitButtonProps={{loading: this.store.formLoading}}
              /> */}
            </div>
     
    );
};
renderUpdateForm=()=>{
  const { getFieldDecorator } = this.props.form;
  const data = this.store.currentData;
  
  let authorEmails
  if(data.authorEmails != null && data.authorEmails != undefined && data.authorEmails!='')
  {
    authorEmails = data.authorEmails.split(';');
  }
  else
  {
    authorEmails = data.authorEmails
  }
  let cmEmails = '';
  if(data.cmEmails != null && data.cmEmails != undefined && data.cmEmails!='')
  {
    cmEmails = data.cmEmails.split(';');
  }
  else
  {
    cmEmails = data.cmEmails
  }
  let editorEmails = '';
  if(data.editorEmails != null && data.editorEmails != undefined && data.editorEmails!='')
  {
    editorEmails = data.editorEmails.split(';');
  }
  else
  {
    editorEmails = data.editorEmails
  }
  return(
    <Form name="normal_login"  className="login-form" initialValues={{ remember: true }} onSubmit={this.handleSubmit}>
        <h3>People - WIP</h3>
        <Row style = {{"background":"#f5f5f5","padding":"10px","margin-bottom":"10px"}}>
        <Col span={24}>
        <Form.Item label="Author Names"  name="Author" >
          {getFieldDecorator('author', {
              initialValue:data.author,
              rules: []
              })(
              <Input disabled style={{ width: '100%' }} />
              )}
          </Form.Item>
         
             {/* <Form.Item label="Author Emails"  name="AuthorEmails" >
              {getFieldDecorator('authorEmails', {
                  initialValue:data.authorEmails,
                  rules: []
                  })(
                  <Input style={{ width: '100%' }} />
                  )}
              </Form.Item> */}

              <Form.Item label="Author Emails"  name="AuthorEmails" >
              {getFieldDecorator('authorEmails', {
                  initialValue:authorEmails,
                  rules: []
                  })(
                    <Select
                      mode="multiple"
                      style={{ width: '100%' }}
                      placeholder="Please select"
                      onSearch={this.validationText}
                      onChange={this.handleChange}
                      
                    >
                      {this.state.children}
                    </Select>,
                    )}
              </Form.Item>

           
              <Form.Item>
                <Button style={{"float":"right","margin-top":"10px"}} type="primary" onClick={()=>this.updateWip(1)} className="login-form-button">Update WIP</Button>
              </Form.Item>
            </Col>
          </Row>

        <Row style = {{"background":"#f5f5f5","padding":"10px","margin-bottom":"10px"}}>
        <Col span={24}>
         <Form.Item label="CM Names"  name="Cm" >
         {getFieldDecorator('cm', {
             initialValue:data.cm,
             rules: []
            })(
             <Input disabled style={{ width: '100%' }} />
            )}
         </Form.Item>
        
              {/* <Form.Item label="CM Emails"  name="CmEmails" >
              {getFieldDecorator('cmEmails', {
                  initialValue:data.cmEmails,
                  rules: []
                  })(
                  <Input style={{ width: '100%' }} />
                  )}
              </Form.Item> */}

              <Form.Item label="CM Emails"  name="CmEmails" >
              {getFieldDecorator('cmEmails', {
                  initialValue:cmEmails,
                  rules: []
                  })(
                    <Select
                      mode="multiple"
                      style={{ width: '100%' }}
                      placeholder="Please select"
                      onSearch={this.validationText}
                      onChange={this.handleChange}
                      
                    >
                      {this.state.children}
                    </Select>,
                    )}
              </Form.Item>
           
              <Form.Item>
                <Button style={{"float":"right","margin-top":"10px"}} type="primary" onClick={()=>this.updateWip(72)}className="login-form-button">Update WIP</Button>
              </Form.Item>
            </Col>
          </Row>

        
         

        <Row style = {{"background":"#f5f5f5","padding":"10px","margin-bottom":"10px"}}>
        <Col span={24}>
         <Form.Item label="Editor Names"  name="Editor" >
         {getFieldDecorator('editor', {
             initialValue:data.editor,
             rules: []
            })(
             <Input disabled style={{ width: '100%' }} />
            )}
         </Form.Item>
            {/* <Form.Item label="Editor Emails"  name="EditorEmails" >
            {getFieldDecorator('editorEmails', {
                initialValue:data.editorEmails,
                rules: []
                })(
                <Input style={{ width: '100%' }} />
                )}
            </Form.Item> */}

            <Form.Item label="Editor Emails"  name="EditorEmails" >
              {getFieldDecorator('editorEmails', {
                  initialValue:editorEmails,
                  rules: []
                  })(
                    <Select
                      mode="multiple"
                      style={{ width: '100%' }}
                      placeholder="Please select"
                      onSearch={this.validationText}
                      onChange={this.handleChange}
                      
                    >
                      {this.state.children}
                    </Select>,
                    )}
              </Form.Item>

            <Form.Item>
             <Button style={{"float":"right","margin-top":"10px"}} type="primary" onClick={()=>this.updateWip(70)} className="login-form-button">Update WIP</Button>
            </Form.Item>
          </Col>
        </Row>
       </Form>
  )
}
updateConfirmValue = (evt)=> {
  this.setState({
    inputConfirmValue: evt.target.value
  });
}
  render() {
   
     const data = this.store.currentData;
     const title = data.id === undefined ? "New Title" : data.abbreviation + " - " + data.publication;
      if(data.projectId>0)
      {
        return (
          <div>
            {this.renderUpdateForm()}
            {this.renderPeopleForm()}
            <Modal
              title={title}
              visible={this.state.visible}
              onOk={this.handleOk}
              onCancel={this.handleCancel}
            >
              <div className="deleteText">Confirm you want to update this email by typing its country: <b>{data.publication}</b></div>
              <div className="deletePara"><Input value={this.state.inputConfirmValue} onChange={this.updateConfirmValue} placeholder={data.publication} /></div>
              {this.state.errormsg ? <div className="errormsg"><sup>**</sup> Country name are not matching</div>:''}
            </Modal>
          </div>
        );
      }
      else{
        return (
          <div>
            {this.renderPeopleForm()}
          </div>
        );
      }
     
   
  }
}

export default Form.create({ name: 'normal_login' })(LooseLeafPeopleDrawer);

// export default WrappedNormalLoginForm;

